(($, duo) => {
  Drupal.behaviors.coachbanner = {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      /* setup anchor links */
      /* ****************** */

      const $coachBanners = $(document).find('.coach-banner');
      $coachBanners.each(function(index, element) {
        const $coachBanner = $(element);

        // check if there is an item below the coach banner:
        const $nextItem = $coachBanner.next();
        if($nextItem.length > 0) {

          // get ID from the destination, or add one if it hasn't got one:
          let anchorId;
          if($nextItem.attr('id') !== undefined) {
            anchorId = $nextItem.attr('id');
          } else {
            const uniqueElementId = 'coachbanner-' + duo.Utils.uniqueId;
            $nextItem.attr('id', uniqueElementId);
            anchorId = uniqueElementId;
          }

          // update anchor-link:
          const $anchorLink = $coachBanner.find('.js-coach-banner-scroll-link');
          if($anchorLink.length > 0) {
            $anchorLink.attr('href', `#${anchorId}`);
          }
        } else {

          // there is no item below the coach banner,
          // so remove the anchor link:
          const $anchorLinkBlock = $coachBanner.find('.coach-banner__scroll-block');
          if($anchorLinkBlock.length > 0) {
            $anchorLinkBlock.attr('hidden', '');
          }

        }
      });

      // Smooth scroll:

      new duo.SmoothScroll({
        selector: '.js-coach-banner-scroll-link',
        moveFocus: false
      });

    }

  };
})(jQuery, window.duo = window.duo || {});
